import { render, staticRenderFns } from "./levelList.vue?vue&type=template&id=bec6c3aa"
import script from "./levelList.vue?vue&type=script&lang=js"
export * from "./levelList.vue?vue&type=script&lang=js"
import style0 from "./levelList.vue?vue&type=style&index=0&id=bec6c3aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports